<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5';
    import SignInPC from '../components/pc';
    import loadScript from '../../../uitl/load-script';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {
                cloud: null
            };
        },
        created() {
            // loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js');
            // loadScript('https://res.wx.qq.com/open/js/cloudbase/1.1.0/cloud.js');
        },
        mounted() {


        }
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>